import { render, staticRenderFns } from "./PostAblitityScoreDetailPage.vue?vue&type=template&id=486068b1"
import script from "./PostAblitityScoreDetailPage.vue?vue&type=script&lang=js"
export * from "./PostAblitityScoreDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports